import React, { useEffect, useState } from "react";
import './sass/styles.scss';
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';
import ErrorIcon from '@material-ui/icons/Error';
import WarningIcon from '@material-ui/icons/Warning';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import moment from "moment";

export const ScheduleNewDetail = () => {
  const [dates, setDates] = useState();
  const [anterior, setAnterior] = useState()
  const [despues, setDespues] = useState()

  useEffect(() => {
    setDates(getDaysForCalendar(new Date()))
  }, [])

  useEffect(() => {
    console.log(dates)
  }, [dates])

  const nextDates = () => {
    setDates(getDaysForCalendar(moment(dates.test2).format()))
  };

  const previousDates = () => {
    setDates(getDaysForCalendar(moment(dates.test1).subtract(3, 'days').format()))
  };


  function getWeek(dataRecived) {
    let fromDate = dataRecived ? new Date(dataRecived) : new Date();
    let sunday = new Date(
      fromDate.setDate(fromDate.getDate() - fromDate.getDay())
    );
    let result = [];

    for (let index = 0; index < 7; index++) {
      result.push(new Date(sunday));
      sunday.setDate(sunday.getDate() + 1);
    }

    return result;
  }

  function getDaysForCalendar(dateRecived) {
    let result = getWeek(dateRecived);
    let getIn = false;
    let counter = 0;
    let innerLastElement = null
    let innerFirstElement = null

    let daysToCome = result.filter((date) => {
      if (new Date(dateRecived).getDate() == date.getDate()) {
        getIn = true;
      }
      if (getIn) {
        if (counter < 4) {
          counter++;
          return date;
        }
      }
    });

    //console.log('daysToCome:', daysToCome)
    const innerArray = structuredClone(daysToCome);
    innerLastElement = innerArray[innerArray.length - 1];
    // console.log('innerLastElement: ', innerLastElement)
    innerFirstElement = innerArray[0];
    const newDateLastElement = moment(innerLastElement).add(1, 'd');
    let InnerResult = getWeek(newDateLastElement);
    //console.log('newDateLastElement', newDateLastElement)
    InnerResult.filter((date) => {
      if (daysToCome.length < 4) {
        daysToCome.push(date);
      }
    });

    let days = daysToCome.map((date) => {
      let day = date.getDate();
      let weekday = date
        .toLocaleString("default", { weekday: "long" })
        .toUpperCase();

      return weekday + " " + day;
    });

    var fechaAnterior = moment(daysToCome[0]).subtract(1, 'days').format();
    var fechaDespues = moment(daysToCome[daysToCome.length - 1]).add(1, 'days').format();


    return {
      prettyDates: days,
      date: daysToCome,
      test1: fechaAnterior,
      test2: fechaDespues
    };
  }


  function Card(data) {
    return (
      <div style={{ border: '1px solid lightGrey', boxShadow: ' 0px 0px 3px 1px rgba(112,112,112,0.5)', marginBottom: '15px', width: '100%', alignSelf: 'center' }}>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignItems: 'center', marginTop: '10px', marginBottom: 10 }}>
          <div style={{ width: '50%', display: 'flex', justifyContent: 'space-evenly', alignItems: 'center' }}>
            <div style={{ width: '20%' }}>
              {
                data.data.icon == 'urgent' ? <EmojiObjectsIcon fontSize="large" style={{ color: '#9f1717' }} /> :
                  data.data.icon == 'warning' ? <WarningIcon fontSize="large" style={{ color: '#eb5400' }} /> :
                    data.data.icon == 'detail' ? <ErrorIcon fontSize="large" style={{ color: '#d68000' }} /> :
                      data.data.icon == 'success' ? <CheckCircleIcon fontSize="large" style={{ color: '#689f38' }} /> :
                        <></>
              }
            </div>
            <div style={{ width: '60%' }}>
              <p style={{ fontFamily: 'arial', fontSize: '20px', fontWeight: 'bold' }}>{data.data.time}</p>
            </div>
          </div>
          <div style={{ width: '50%', display: 'flex', flexDirection: 'center', justifyContent: 'center' }}>
            <p style={{ fontFamily: 'arial', fontSize: '20px' }}>{data.data.place}</p>
          </div>
          <div style={{ width: '50%', display: 'flex', justifyContent: 'space-evenly', alignItems: 'flex-start', flexDirection: 'column', marginLeft: '30px' }}>
            <div style={{ width: '20%' }}>
              <p style={{ fontFamily: 'arial', fontSize: '17px' }}>Tecnicoooooooooo</p>
            </div>
            <div style={{ width: '60%' }}>
              <p style={{ fontFamily: 'arial', fontSize: '15px', fontWeight: 'bold' }}>{data.data.technician}</p>
            </div>
          </div>
          <div style={{ width: '50%', display: 'flex', justifyContent: 'space-evenly', alignItems: 'flex-start', flexDirection: 'column', marginLeft: '30px' }}>
            <div style={{ width: '20%' }}>
              <p style={{ fontFamily: 'arial', fontSize: '17px' }}>Medico</p>
            </div>
            <div style={{ width: '60%' }}>
              <p style={{ fontFamily: 'arial', fontSize: '15px', fontWeight: 'bold' }}>{data.data.doctor}</p>
            </div>
          </div>
          <div style={{ width: '50%', display: 'flex', justifyContent: 'space-evenly', alignItems: 'flex-start', flexDirection: 'column', marginLeft: '30px' }}>
            <div style={{ width: '20%' }}>
              <p style={{ fontFamily: 'arial', fontSize: '17px' }}>#Programación</p>
            </div>
            <div style={{ width: '60%' }}>
              <p style={{ fontFamily: 'arial', fontSize: '15px', fontWeight: 'bold' }}>{data.data.programmingId}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  function InfoCard() {
    return (
      <div style={{ marginBottom: '15px', width: '100%', alignSelf: 'center', background: '#e5e9f2', borderRadius: '10px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly', marginTop: '10px', marginBottom: 10 }}>
          <div style={{ width: '100%', marginTop: '15px', marginLeft: '25px' }}>
            <p style={{ fontFamily: 'arial', fontSize: '20px', fontWeight: 'bold' }}>Cirugias no surtidas</p>
          </div>

          <div style={{ width: '100%', display: 'flex', alignItems: 'center', marginTop: '20px', marginLeft: '25px' }}>
            <div>
              <EmojiObjectsIcon fontSize="large" style={{ color: '#9f1717' }} />
            </div>
            <div>
              <p style={{ fontFamily: 'arial', fontSize: '20px', marginLeft: '15px' }}>-6hrs para iniciar la cirugia</p>
            </div>
          </div>

          <div style={{ width: '100%', display: 'flex', alignItems: 'center', marginTop: '20px', marginLeft: '25px' }}>
            <div>
              <WarningIcon fontSize="large" style={{ color: '#eb5400' }} />
            </div>
            <div>
              <p style={{ fontFamily: 'arial', fontSize: '20px', marginLeft: '15px' }}>-8hrs para iniciar la cirugia</p>
            </div>
          </div>

          <div style={{ width: '80%', display: 'flex', alignItems: 'center', marginTop: '20px', marginLeft: '25px' }}>
            <div>
              <ErrorIcon fontSize="large" style={{ color: '#d68000' }} />
            </div>
            <div>
              <p style={{ fontFamily: 'arial', fontSize: '20px', marginLeft: '15px' }}>Cirugias sin surtir con más de 8 horas para que inicie la cirugia.</p>
            </div>
          </div>

          <div style={{ width: '100%', marginTop: '20px', marginLeft: '25px' }}>
            <p style={{ fontFamily: 'arial', fontSize: '20px', fontWeight: 'bold' }}>Cirugias no surtidas</p>
          </div>

          <div style={{ width: '80%', display: 'flex', alignItems: 'center', marginTop: '20px', marginLeft: '25px' }}>
            <div>
              <CheckCircleIcon fontSize="large" style={{ color: '#689f38' }} />
            </div>
            <div>
              <p style={{ fontFamily: 'arial', fontSize: '20px', marginLeft: '15px' }}>Cirugías surtidas independientemente las horas para que inicie la cirugia.</p>
            </div>
          </div>

        </div>
      </div>
    );
  }

  return (

    <div className="container">
      <div style={{ display: 'flex', marginTop: '-80px', marginLeft: '40px', marginRight: '40px' }}>
        <div className="Schedulecolumn" style={{ width: '80%' }}>
          <div className="cardSchedule" style={{ background: '#4c7fb6' }}>
            <div className="card-contentSchedule">
              <h2>CIRUGIAS PROGRAMADAS</h2>
            </div>
          </div>

          <p style={{ fontFamily: 'arial', fontSize: '20px', fontWeight: 'bold', marginTop: 20, marginBottom: 20, marginLeft: 50 }}>LUNES 21 AGOSTO 2021</p>

          <Card data={{ icon: 'urgent', time: '4:00 PM', place: 'Hospital de la Luz', technician: 'Mauricio Cortez', doctor: 'Mauricio Cortez', programmingId: '123456' }} />
          <Card data={{ icon: 'urgent', time: '2:00 PM', place: 'Hospital los Angeles', technician: 'Mauricio Cortez', doctor: 'Mauricio Cortez', programmingId: '123456' }} />
          <Card data={{ icon: 'warning', time: '12:00 PM', place: 'Hospital de la Mujer', technician: 'Mauricio Cortez', doctor: 'Mauricio Cortez', programmingId: '123456' }} />
          <Card data={{ icon: 'success', time: '10:00 AM', place: 'Hospital de la Luz', technician: 'Mauricio Cortez', doctor: 'Mauricio Cortez', programmingId: '123456' }} />
          <Card data={{ icon: 'success', time: '8:00 AM', place: 'Hospital de la Luz', technician: 'Mauricio Cortez', doctor: 'Mauricio Cortez', programmingId: '123456' }} />

          <p style={{ fontFamily: 'arial', fontSize: '20px', fontWeight: 'bold', marginTop: 20, marginBottom: 20, marginLeft: 50 }}>MARTES 22 AGOSTO 2021</p>

          <Card data={{ icon: 'urgent', time: '4:00 PM', place: 'Hospital de la Luz', technician: 'Mauricio Cortez', doctor: 'Mauricio Cortez', programmingId: '123456' }} />
          <Card data={{ icon: 'urgent', time: '2:00 PM', place: 'Hospital los Angeles', technician: 'Mauricio Cortez', doctor: 'Mauricio Cortez', programmingId: '123456' }} />
          <Card data={{ icon: 'warning', time: '12:00 PM', place: 'Hospital de la Mujer', technician: 'Mauricio Cortez', doctor: 'Mauricio Cortez', programmingId: '123456' }} />

        </div>
        <div className="Schedulecolumn" style={{ width: '30%' }}>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignItems: 'center' }}>
            <div >
              <h2>7:00 AM</h2>
            </div>
          </div>

          <InfoCard />

        </div>
      </div>
    </div >
  );
};
